import React, { type ComponentType } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import {
	type HubExtensionsWrapperProps,
	type ProductDependenciesProviderProps,
} from '@atlassian/company-hub-common';

import type { SpotlightParameters } from '../../../types';

import { Spotlight } from './spotlight';

export type SpotlightExtensionProps = HubExtensionsWrapperProps<SpotlightParameters> & {
	propsProvider: ComponentType<ProductDependenciesProviderProps>;
};

export const SpotlightExtension = ({
	contentId,
	extensionNode,
	propsProvider,
}: SpotlightExtensionProps): React.JSX.Element => {
	const { parameters = '' } = extensionNode || {};

	if (!parameters) {
		return <Box testId="no-params-empty-state" />;
	}

	return (
		<Spotlight extensionNode={extensionNode} contentId={contentId} PropsProvider={propsProvider} />
	);
};
